export const GET_CART = 'carts/GET_CART';
export const SET_CART = 'carts/SET_CART';

export const CREATE_CART_ITEM = 'carts/CREATE_CART_ITEM';
export const UPDATE_CART_ITEM = 'carts/UPDATE_CART_ITEM';
export const SET_DISCOUNT_CODE = 'carts/SET_DISCOUNT_CODE';
export const REMOVE_CART_ITEM = 'carts/REMOVE_CART_ITEM';

